import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, Activity, Users, ChevronRight } from 'lucide-react';

const Hero = () => {
  const demoLink = "https://calendly.com/avishkar-easemytkt/30min";

  return (
    <section className="hero section-padding bg-gradient">
      <div className="container hero-grid">
        <motion.div
          className="hero-content"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="badge">AI-Powered Autonomous IT Operations</div>
          <h1>AI-Powered Autonomous IT Operations</h1>
          <h2 className="subheadline">Reduce MTTR. Eliminate Manual Triage. Improve SLA Compliance.</h2>
          <p className="description">
            Raptic91<sup>™</sup> transforms IT support into an autonomous AI-driven operations layer that diagnoses, assigns, and resolves tickets with minimal human intervention.
          </p>

          <div className="hero-ctas">
            <a href={demoLink} className="btn btn-primary">Book Enterprise Demo</a>
          </div>

          <div className="trust-indicators">
            <div className="trust-item"><ShieldCheck size={18} /> Enterprise-Grade Security</div>
            <div className="trust-item"><Lock size={18} /> Secure Data Handling</div>
            <div className="trust-item"><Activity size={18} /> 99.9% Uptime SLA</div>
            <div className="trust-item"><Users size={18} /> Privacy-Focused</div>
          </div>
        </motion.div>

        <motion.div
          className="hero-visual"
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <div className="dashboard-mock light-theme">
            <div className="mock-header">
              <div className="mock-dots"><span></span><span></span><span></span></div>
              <div className="mock-title">Raptic91<sup>™</sup> Operations Console</div>
              <div className="mock-user"></div>
            </div>
            <div className="mock-body">
              <div className="mock-sidebar">
                <div className="sidebar-item active"></div>
                <div className="sidebar-item"></div>
                <div className="sidebar-item"></div>
                <div className="sidebar-item"></div>
              </div>
              <div className="mock-main">
                <div className="mock-grid">
                  <div className="mock-panel ticket-dashboard">
                    <div className="panel-header">Active Incidents</div>
                    <div className="ticket-list">
                      <div className="ticket-row"><span className="status high"></span><span>Database connection failure</span></div>
                      <div className="ticket-row"><span className="status medium"></span><span>VPN access request</span></div>
                      <div className="ticket-row"><span className="status auto"></span><span>SSL Cert Auto-renewed</span></div>
                    </div>
                  </div>
                  <div className="mock-panel ai-panel">
                    <div className="panel-header">AI Classification</div>
                    <div className="ai-content">
                      <div className="ai-tag">Category: <span className="highlight">Infrastructure</span></div>
                      <div className="ai-tag">Intent: <span className="highlight">System Outage</span></div>
                      <div className="confidence-meter">
                        <span>Confidence Score</span>
                        <div className="meter-bg"><div className="meter-fill" style={{ width: '98%' }}></div></div>
                        <span className="count">98.4%</span>
                      </div>
                    </div>
                  </div>
                  <div className="mock-panel sla-panel">
                    <div className="panel-header">SLA Status</div>
                    <div className="sla-visual">
                      <div className="sla-ring">
                        <span className="sla-val">100%</span>
                      </div>
                      <div className="sla-label">Compliance Rank</div>
                    </div>
                  </div>
                  <div className="mock-panel assignment-panel">
                    <div className="panel-header">Smart Assignment</div>
                    <div className="flow-visual">
                      <div className="flow-step">Ticket #1024 <ChevronRight size={12} /></div>
                      <div className="flow-step-ai">AI Engine <ChevronRight size={12} /></div>
                      <div className="flow-step-res">Resolved</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="visual-glow"></div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
